export default {
    createLeaveType: 'Create Leave Type',
    updateLeaveType: 'Edit Leave Type',
    leaveType: 'Leave Type',
    gender: 'Gender',
    numberOfDays: 'Days',
    resetDay: 'Reset Day',
    resetMonth: 'Reset Mouth',
    employment: 'Employment',
    fullTimeLeave: 'Full-Time Leave',
    personalLeave: 'Personal Leave',
    sickLeave: 'Sick Leave',
    annualResetDate: 'Annual Reset Date',
    saveChanges: 'Save Changes',
    probation: 'Probation',
    probationLeave: 'Probation Leave',
    save: 'Save',
    thisFieldIsRequired: 'This field is required',
    incorrectPhoneNubmer: 'Incorrect day',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    congratulation: 'Congratulation',
    errorMessage: 'Error message',
    leaveTypeIsCreated: 'Leave Type is created',
    leaveTypeIsUpdated: 'Leave Type is updated'
}
